import { useState } from 'react';
import { toast } from 'sonner';
import { GitBranchPlus } from 'lucide-react';
import { PIPE_TYPES, uid } from '../lib/model';
import { cadLayers, colorOf } from './CadPanel';
import { flyTo } from '../lib/vis';

// turn all lines of one DXF layer into real project pipes
export default function CadAdopt({ t, project, updateProject }) {
  const cad = project.cad;
  const [sel, setSel] = useState(null);
  const [f, setF] = useState({ type: 'water', dn: '', material: '' });
  const layers = cadLayers({ ents: cad.ents.filter((e) => e.type === 'line') });
  if (!layers.length) return null;
  const adopt = () => {
    const lines = cad.ents.filter((e) => e.type === 'line' && e.layer === sel && e.pts.length > 1);
    const pipes = lines.map((e, i) => ({ id: uid('pipe'), name: `${sel} ${i + 1}`, type: f.type, dn: f.dn.trim(), material: f.material.trim(), points: e.pts.map((p) => [p[0], p[1]]), imported: 'cad', cadLayer: sel }));
    updateProject((pr) => ({ ...pr, pipes: [...pr.pipes, ...pipes], cad: { ...pr.cad, off: [...new Set([...(pr.cad.off || []), sel])] } }));
    flyTo(pipes.flatMap((p) => p.points));
    toast.success(`${t.cadAdoptDone}: ${pipes.length} ${t.impPipes} (${sel})`);
    setSel(null);
  };
  return (
    <div className="cad-adopt" data-testid="cad-adopt">
      <small className="muted">{t.cadAdoptHint}</small>
      {layers.map(([k, n]) => (
        <div key={k} className="cad-adopt-row">
          <span><i className="lg-line" style={{ background: colorOf(k) }} /> <b>{k}</b> <small>({n})</small>{project.pipes.some((p) => p.cadLayer === k) && <small className="cad-adopted"> ✓ {t.cadAdopted}</small>}</span>
          <button className="btn btn-outline btn-sm" data-testid={`cad-adopt-btn-${k}`} onClick={() => setSel(sel === k ? null : k)}><GitBranchPlus size={13} /> {t.cadAdopt}</button>
        </div>
      ))}
      {sel && (
        <div className="cad-adopt-form" data-testid="cad-adopt-form">
          <select data-testid="cad-adopt-type" value={f.type} onChange={(e) => setF({ ...f, type: e.target.value })}>{Object.keys(PIPE_TYPES).filter((k) => k !== 'leak').map((k) => <option key={k} value={k}>{t['type_' + k] || k}</option>)}</select>
          <input data-testid="cad-adopt-dn" placeholder="DN" inputMode="numeric" value={f.dn} onChange={(e) => setF({ ...f, dn: e.target.value })} />
          <input data-testid="cad-adopt-material" placeholder={t.cadMaterial} value={f.material} onChange={(e) => setF({ ...f, material: e.target.value })} />
          <button className="btn btn-dark btn-sm" data-testid="cad-adopt-confirm" onClick={adopt}>{t.cadAdoptGo} „{sel}“</button>
        </div>
      )}
    </div>
  );
}
